module.exports = __webpack_public_path__ + "img/head-side.301faea9.svg";